import React from 'react';
import { HStack, Icon, Link as ChakraLink, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const DetailItem = ({ icon, text, iconVisible = 'show', href = '', ...props }) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {text && (
    <HStack alignItems="center" py={1}>
      <Icon as={icon} boxSize={4} visibility={iconVisible} />
      {href
        ? <ChakraLink color="primaryScale.600" href={href} {...props}>{text}</ChakraLink>
        : <Text {...props}>{text}</Text>}
    </HStack>
    )}
  </>
);

DetailItem.propTypes = {
  icon: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  iconVisible: PropTypes.string,
  href: PropTypes.string
};

export default DetailItem;
